import { Endorsement } from "../../../types/Endorsement.types";

import { getMockHousehold } from "./getMockHousehold";

/**
 * @see https://devservices.hagerty.com/Hagerty/Usa/insuranceops/swagger/index#/Endo
 */
const ENDORSEMENTS: Endorsement[] = [
  {
    Id: 97324188,
    PolicyNumber: "97324188",
    UnformattedPolicyNumber: null,
    FormattedPolicyNumber: null,
    EffectiveDate: "2022-06-23T00:01:00",
    ExpirationDate: "2023-06-23T00:01:00",
    ProposedEffectiveDate: "2022-06-23T00:01:00",
    Household: getMockHousehold(),
    PolicyType: "ENDO",
    PolicyCategory: "ENDO",
    PolicyStatus: "SAVE",
    PolicyAddress: {
      Id: 339147,
      LineOne: "14402 Purdy St.",
      LineTwo: "",
      City: "Westminster",
      County: "Orange",
      StateRegion: "CA",
      PostalCode: "92683-4637",
      Country: "US",
      Township: null,
      Type: null,
      EffectiveDate: null,
      ExpirationDate: null,
      IsDefault: null,
      IsSeasonal: false,
      Municipality: null,
    },
    Premium: 184,
    FinalPremium: 184,
    ProgramVersion: 1887,
    ProratedEndorsementPremium: 0,
    ProratedFinalEndorsementPremium: 0,
    TotalInsuredValue: 21000,
    Vehicles: [
      {
        Id: 506688160,
        AddInProgress: false,
        RateType: "H",
        VehicleCoverages: [
          {
            Name: "Collision",
            Limit: "$0 Deductible",
            Type: 4,
            Premium: 58,
            PolicyCoverageId: null,
            CoverageGroup: "COLL",
            CoverageParentGroup: "COLL",
          },
          {
            Name: "Comprehensive",
            Limit: "$0 Deductible",
            Type: 5,
            Premium: 72,
            PolicyCoverageId: null,
            CoverageGroup: "OTC",
            CoverageParentGroup: "OTC",
          },
        ],
        AdditionalCoverages: [],
        SequenceNumber: 1,
        AdditionalInterests: [
          {
            Id: 14733125,
            ItemFK: 506698887,
            Name: "string",
            AdditionalInterestType: "LIEN",
            Description: "Lienholder / Loss Payee",
            Address: {
              Country: "US",
              Township: "Township",
              Type: "string",
              EffectiveDate: "2022-07-21T04:57:08.446Z",
              ExpirationDate: "2022-07-21T04:57:08.446Z",
              IsDefault: true,
              IsSeasonal: true,
              Id: 0,
              LineOne: "Best Banc Building",
              LineTwo: "60 N. Water St.",
              City: "New Bedford",
              County: "Bristol",
              StateRegion: "MA",
              PostalCode: "02740-6336",
            },
            PersistentId: 1,
            IsEntity: false,
            IsIndividual: true,
          },
        ],
        PolicyItemNumber: 1,
        HasIdCard: true,
        Features: [],
        ItemType: "Auto",
        VehicleBodyEngineId: 26712,
        VehicleId: 10573,
        Year: 1968,
        Make: {
          Key: 72,
          Value: "CHEVROLET",
        },
        Model: {
          Key: 1313,
          Value: "CAMARO",
        },
        SubModel: {
          Key: 397,
          Value: "Base",
        },
        BodyStyle: {
          Key: 304,
          Value: "2D COUPE",
        },
        Engine: {
          Key: 2673,
          Value: "8-cyl. 327cid/210hp 2bbl LF7",
        },
        Modifications: null,
        ModificationType: "STOCK",
        StorageType: "HOM",
        StorageAddress: null,
        Usage: {
          Business: false,
          Daily: false,
          DrivenToWork: false,
          Pleasure: false,
          UtilityOffRoad: false,
          Motorsports: false,
          Show: false,
        },
        VIN: "124378N330476",
        RegistrationType: "Standard",
        Ownership: {
          IsOwnedByClient: true,
          IsFinancedOrLeased: false,
          IsLeased: false,
          InsuranceProvider: "UNKN",
        },
        RateAttribute: "UNKN",
        AnnualMileage: 501,
        YearsOwned: 44,
        Value: 21000,
      },
    ],
    PolicySource: null,
    StateRegion: "CA",
    StateRegionDescription: "California",
    Agency: null,
    InitiatedByProducer: null,
    SubmittedByProducer: null,
    PolicyCoverages: [
      {
        Name: "Liability - BI",
        Limit: "$100000 / $300000",
        Type: 2,
        Premium: 27,
        PolicyCoverageId: 778673836,
        CoverageGroup: "BI",
        CoverageParentGroup: "LIAB",
      },
      {
        Name: "Liability - PD",
        Limit: "$50000",
        Type: 8,
        Premium: 3,
        PolicyCoverageId: 778673837,
        CoverageGroup: "PD",
        CoverageParentGroup: "LIAB",
      },
      {
        Name: "Medical Payments",
        Limit: "$5000",
        Type: 12,
        Premium: 10,
        PolicyCoverageId: 778673838,
        CoverageGroup: "MP",
        CoverageParentGroup: "MP",
      },
      {
        Name: "Uninsured Motorists BI Split Limits",
        Limit: "$30000 / $60000",
        Type: 20,
        Premium: 6,
        PolicyCoverageId: 778673839,
        CoverageGroup: "UM",
        CoverageParentGroup: "UM",
      },
      {
        Name: "Limited Earthquake Coverage",
        Limit: "$1000000",
        Type: 237,
        Premium: 8,
        PolicyCoverageId: 778673842,
        CoverageGroup: "OTH_O",
        CoverageParentGroup: "OTC",
      },
    ],
    AdditionalCoverages: [
      {
        Name: "Spare Parts (for your car)",
        Limit: "",
        Type: 278,
        Premium: 0,
        PolicyCoverageId: 778673843,
        CoverageGroup: "SP",
        CoverageParentGroup: "SCOV",
      },
    ],
    STPReadyInd: null,
    SourceReferencedPolicy: "1N94118-14",
    IsCreatedFromWeb: true,
    EndorsementEffectiveDate: null,
    PolicyInceptionDate: "2008-06-23T00:01:00",
    FullEndorsementPremium: 0,
    Carrier: "Markel",
    Underwriter: "Essentia Insurance Company",
  },
];

export const getMockEndorsements = (endoNumberIds: string[]): Endorsement[] =>
  ENDORSEMENTS.filter(({ Id }) => endoNumberIds.includes(String(Id)));
